import * as React from 'react';
import { Header, Navigation, Filter, Footer } from '../../../shared';
import Rest from 'src/services/Rest';
import { client } from 'src';
import { QueryFilter } from 'src/component/shared';

import './MarketShares.scss';

import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Grid, Typography, Tab, AppBar, Tabs, LinearProgress, Menu, MenuItem } from "@material-ui/core";
import { MarketProviderFilter } from "../shared/filter/market-provider-filter/MarketProviderFilter";
import { MarketStampFilter } from "../shared/filter/market-stamp-filter/MarketStampFilter";
import { MarketCategoryFilter } from "../shared/filter/market-category-filter/MarketCategoryFilter";
import { MarketFilterChip } from "../shared/chips/MarketSharesChip";
import { MarketPublisherVolume } from '../publishers/volume/publisher.volume';
import { MarketPublisherConsolidated } from '../publishers/consolidated/publisher.consolidated';
import { MarketPublisherBilling } from '../publishers/billing/publisher.billing';
import { MarketPrice } from '../price/MarketPrice';
import { MarketCategoriesThirtyDays } from '../categories/thirty-days/MarketCategoriesThirtyDays';
import { MarketCategoriesLastMonths } from '../categories/last-months/MarketCategoriesLastMonths';
import { MarketShareBookstoreShareBillingEvolutionByMonth } from '../../bookstore/marketShare/billing-evolution-by-month/MarketShareBookstoreShareBillingEvolutionByMonth';

const QUERY_GET_INITIAL_PROVIDERS = ` query { marketBestselledProvider { id, provider } } `;

const QUERY_GET_STORES = ` query { marketEconomicGroups { id, grupo, stores { name, state } } } `;

// tslint:disable-next-line:no-empty-interface
export interface IMarketSharesProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketSharesState {
    anchorElCategory?: HTMLElement;
    anchorElPublisher?: HTMLElement;
    economicGroups: any[];
    loading: boolean;
    marketProviderFilterChecked: string[];
    marketStampFilterChecked: string[];
    categoryMenuValue: number;
    publisherMenuValue: number;
    shareCategoryMenuOpen: boolean;
    sharePublisherMenuOpen: boolean;
    tabValue: number;
}

function TabContainer(props: any) {
    return (
        <Typography component="div" style={{ paddingTop: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

function LinkTab(props: any) {
    return (
      // tslint:disable-next-line:jsx-no-lambda
      <Tab className="marketTab" onClick={event => event.preventDefault()} {...props} />
    );
}

export class MarketShares extends React.Component<IMarketSharesProps, IMarketSharesState> {
    constructor(props: IMarketSharesProps) {
        super(props);

        this.state = {
            anchorElCategory: undefined,
            anchorElPublisher: undefined,
            categoryMenuValue: 0,
            economicGroups: [],
            loading: true,
            marketProviderFilterChecked: [],
            marketStampFilterChecked: [],
            publisherMenuValue: 0,
            shareCategoryMenuOpen: false,
            sharePublisherMenuOpen: false,
            tabValue: 0,
        };
        this.startLoad = this.startLoad.bind(this);
    }

    public async componentWillMount () {
        const body = {
            "operationName":"",
            "query":QUERY_GET_INITIAL_PROVIDERS
        };

        await Rest.GraphqlPOST(body)
            .then( result  => {
                if(result != null && result !== undefined 
                    && result.data != null && result.data !== undefined && result.data.data != null && result.data.data !== undefined
                    && result.data.data.marketBestselledProvider != null && result.data.data.marketBestselledProvider !== undefined && result.data.data.marketBestselledProvider.length > 0) {

                    const selectedIds = result.data.data.marketBestselledProvider.map(( item:any ) => item.id.toString());

                    const queryStr = `query marketStampFilter($customFilter:MarketShareCustomFilter){marketStampFilter(marketShareCustomFilter: $customFilter){id,provider,providerFatherId}}`;
                    const variables = `{"customFilter":{"isChart":false,"providerName":"","category":[],"provider":[${selectedIds.toString()}]}}`;

                    const bodyStampRequest = {
                        "operationName":"",
                        "query":queryStr,
                        "variables":variables
                    };
                    Rest.GraphqlPOST(bodyStampRequest)
                        .then( resultStamp  => {
                            if(resultStamp != null && resultStamp !== undefined 
                                && resultStamp.data != null && resultStamp.data !== undefined && resultStamp.data.data != null && resultStamp.data.data !== undefined
                                && resultStamp.data.data.marketStampFilter != null && resultStamp.data.data.marketStampFilter !== undefined && resultStamp.data.data.marketStampFilter.length > 0) {

                                const checkedStamps = resultStamp.data.data.marketStampFilter.map(( item:any ) => item.id.toString());
                                client.writeData({ data: { marketStampFilterChecked: checkedStamps } });
                                client.writeData({ data: { FILTER_marketStampFilterChecked: checkedStamps } });

                                if(resultStamp.data.data.marketStampFilter!=null && resultStamp.data.data.marketStampFilter !== undefined 
                                    && resultStamp.data.data.marketStampFilter.length > 0) {
                                        resultStamp.data.data.marketStampFilter.map( (item:any) => {
                                        item.__typename = 'json';
                                        item.__id = resultStamp.data.data.marketStampFilter.indexOf(item).toString();
                                    });
                                    client.writeData({ data: { FILTER_marketStampFilterCheckedObj: {'marketStampFilterCheckedObj':resultStamp.data.data.marketStampFilter, '__typename':  'marketStampFilterCheckedObj'} } });
                                }
                                
                                client.writeData({ data: { marketProviderFilterChecked: selectedIds } });
                                client.writeData({ data: { FILTER_marketProviderFilterChecked: selectedIds } });
                                QueryFilter.updateMutationMarket();

                                this.setState({ 
                                    loading: false,
                                    marketProviderFilterChecked: selectedIds, 
                                    marketStampFilterChecked: resultStamp.data.data.marketStampFilter 
                                });
                                return;
                            }
                        });

                }
            });

        const bodyStores = {
            "operationName":"",
            "query": QUERY_GET_STORES
        };

        await Rest.GraphqlPOST(bodyStores)
            .then( result  => {
                if(result != null && result !== undefined 
                    && result.data != null && result.data !== undefined && result.data.data != null && result.data.data !== undefined
                    && result.data.data.marketEconomicGroups != null && result.data.data.marketEconomicGroups !== undefined && result.data.data.marketEconomicGroups.length > 0) {
                    this.setState( {economicGroups: result.data.data.marketEconomicGroups});
                }
            });
    }

    public startLoad () {
        this.setState({ loading: true });
    }

    public render() {

        let filters : any[] = [];
        const onlyOneCategory = this.state.tabValue === 2 && this.state.categoryMenuValue === 1;
        const showCategory = this.state.tabValue === 2 && this.state.categoryMenuValue === 0;
        if(this.state.marketProviderFilterChecked != null && this.state.marketProviderFilterChecked !== undefined && this.state.marketProviderFilterChecked.length > 0) {
            filters = [
                <MarketProviderFilter key={1} marketProviderFilterCheckedProp={this.state.marketProviderFilterChecked} startLoad={this.startLoad} isLoading={this.state.loading} />,
                <MarketStampFilter key={4}  marketStampFilterCheckedProp={this.state.marketStampFilterChecked} isLoading={this.state.loading} />,
                <MarketCategoryFilter key={3} onlyOneCategory={onlyOneCategory} />
            ];
        }

        if(this.state.tabValue === 2 && this.state.categoryMenuValue === 0) {
            filters.splice(2,1);
        }

        if(this.state.marketStampFilterChecked.length === 0) {
            filters.splice(1,1);
        }

        if (this.state.tabValue === 3) {
            filters = [];
        }
        
        const loading = this.state.loading;
        const { anchorElPublisher, anchorElCategory } = this.state;
        let publisherTabName = "Share Editoras";
        if(this.state.publisherMenuValue === 0) {
            publisherTabName += " - Volume";
        } else if (this.state.publisherMenuValue === 1){
            publisherTabName += " - Faturamento";
        } else if (this.state.publisherMenuValue === 2){
            publisherTabName += " - Consolidado";
        }

        let categoryTabName = "Categorias";
        if(this.state.categoryMenuValue === 0) {
            categoryTabName += " - Crescimento";
        } else if (this.state.categoryMenuValue === 1){
            categoryTabName += " - Comparativo";
        }

        return (
            <div>
                
                <div className="marketPanel"> 
                    <Header
                        title={"Painel de Mercado"}
                        name={"Mercado"}
                        link={'/dashboard'}
                    />
                    <Navigation
                        name={"Mercado"}
                        linkDefault={"/market/shares"}
                        link={"/publisher/analytical"}
                        linkTitle={"Produtos"}
                        painel={3}
                        icon={<ChevronRightIcon />}
                        economicGroups={this.state.economicGroups}
                    />

                    {loading ? <LinearProgress /> :
                    <div className="wrapper">
                        {filters.length > 0 && <Filter filters={filters} />}
                        {filters.length > 0 && <MarketFilterChip onlyOneCategory={onlyOneCategory} showCategory={showCategory} />}
                        <AppBar position="static" style={{ backgroundColor: '#FFFF', marginTop: 20 }}>
                            <Tabs fullWidth={true} value={this.state.tabValue} onChange={this.handleChangeTab} 
                                centered={true} textColor="primary" indicatorColor="primary">
                                <LinkTab icon={this.state.sharePublisherMenuOpen ? <ExpandLess /> : <ExpandMore />} 
                                    label={publisherTabName} onClick={this.handleSharePublishersClick} />

                                <LinkTab label="Preço e Ticket" />

                                <LinkTab icon={this.state.shareCategoryMenuOpen ?  <ExpandLess /> : <ExpandMore />} 
                                    label={categoryTabName} onClick={this.handleShareCategoriesClick} />

                                <LinkTab label="Mercado" />

                                <Menu
                                    className="share-editora-options"
                                    anchorEl={anchorElPublisher}
                                    open={Boolean(anchorElPublisher)}
                                    onClose={this.handleSharePublishersMenuClose}
                                >
                                    <MenuItem onClick={this.handleSharePublishersMenuChoose.bind(this, 0)} >
                                        Volume
                                    </MenuItem>
                                    <MenuItem onClick={this.handleSharePublishersMenuChoose.bind(this, 1)} >
                                        Faturamento
                                    </MenuItem>
                                    <MenuItem onClick={this.handleSharePublishersMenuChoose.bind(this, 2)} >
                                        Consolidado
                                    </MenuItem>
                                </Menu>

                                <Menu
                                    className="share-editora-options"
                                    anchorEl={anchorElCategory}
                                    open={Boolean(anchorElCategory)}
                                    onClose={this.handleShareCategoriesMenuClose}
                                >
                                    <MenuItem onClick={this.handleShareCategoriesMenuChoose.bind(this, 0)} >
                                        Categoria - Crescimento
                                    </MenuItem>
                                    <MenuItem onClick={this.handleShareCategoriesMenuChoose.bind(this, 1)} >
                                        Categoria - Comparativo
                                    </MenuItem>
                                </Menu>
                            </Tabs>
                        </AppBar>
                        {this.state.tabValue === 0 && <TabContainer>
                            <Grid container={true} className="publisher-sale-panel panel-grid MarketSharePublisher" spacing={16} >
                                <Grid item={true} xs={12} md={12} className="market-share-panel">

                                    {this.state.publisherMenuValue === 0 && <MarketPublisherVolume />}
                                    {this.state.publisherMenuValue === 1 && <MarketPublisherBilling />}
                                    {this.state.publisherMenuValue === 2 && <MarketPublisherConsolidated />}
                                    
                                </Grid>
                            </Grid>
                        </TabContainer>}
                        {this.state.tabValue === 1 && <TabContainer>
                            <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16} >
                                <Grid item={true} xs={12} md={12} className="market-share-panel">
                                    <MarketPrice />
                                </Grid>
                            </Grid>
                        </TabContainer>}
                        {this.state.tabValue === 2 && <TabContainer>
                            <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16} >
                                <Grid item={true} xs={12} md={12} className="market-share-panel">
                                    {this.state.categoryMenuValue === 0 && <MarketCategoriesThirtyDays />}
                                    {this.state.categoryMenuValue === 1 && <MarketCategoriesLastMonths />}
                                </Grid>
                            </Grid>
                        </TabContainer>}
                        {this.state.tabValue === 3 && <TabContainer>
                            <Grid container={true} className="publisher-sale-panel panel-grid" spacing={16} >
                                <Grid item={true} xs={12} md={12} className="market-share-panel">
                                    <MarketShareBookstoreShareBillingEvolutionByMonth filter={['store']} />
                                </Grid>
                            </Grid>
                        </TabContainer>}
                    </div>}
                    <Footer />
                </div>
            
            </div>
        );
    }


    private handleChangeTab = (event: any, tabValue: any) => {
        if(tabValue === 1 || tabValue === 3) {
            this.setState({ tabValue });
        }
        event.stopPropagation();
    };

    private handleSharePublishersClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        this.setState({ anchorElPublisher: event.currentTarget, sharePublisherMenuOpen: !this.state.sharePublisherMenuOpen });
    };

    private handleSharePublishersMenuClose = () => {
        this.setState({ anchorElPublisher: undefined, sharePublisherMenuOpen: false });
    };

    private handleSharePublishersMenuChoose = (publisherMenuValue: number) => {
        this.setState({ publisherMenuValue, anchorElPublisher: undefined, sharePublisherMenuOpen: false, tabValue: 0 });
    };

    private handleShareCategoriesClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        this.setState({ anchorElCategory: event.currentTarget, shareCategoryMenuOpen: !this.state.shareCategoryMenuOpen });
    };

    private handleShareCategoriesMenuClose = () => {
        this.setState({ anchorElCategory: undefined, shareCategoryMenuOpen: false });
    }

    private handleShareCategoriesMenuChoose = (categoryMenuValue: number) => {
        this.setState({ categoryMenuValue, anchorElCategory: undefined, shareCategoryMenuOpen: false, tabValue: 2 });
    };
}



// WEBPACK FOOTER //
// ./src/component/market/general/shares/MarketShares.tsx